export default {
    methods: {
        cloneObject(object) {
            return JSON.parse(JSON.stringify(object));
        }
    }
};
